/**
 * Single-letter weekday headers for the filter calendar (HAT-1238).
 *
 * react-datepicker / date-fns hand the formatter a wide name ("יום ראשון"),
 * an abbreviated one ("יום א׳") or a geresh letter ("א׳"). A fixed-width
 * cell that receives any of those overflows a 280px Fold cover. The Figma
 * weekday row is seven equal FILL columns of א–ש (or S M T W T F S), so
 * this always returns exactly one letter.
 */
const WEEKDAY_RULES: [RegExp, string][] = [
  [/שבת/i, 'ש'],
  [/ראשון|יום\s*א/i, 'א'],
  [/שלישי|יום\s*ג/i, 'ג'],
  [/רביעי|יום\s*ד/i, 'ד'],
  [/חמישי|יום\s*ה/i, 'ה'],
  [/שישי|יום\s*ו/i, 'ו'],
  [/שני|יום\s*ב/i, 'ב'],
  [/Saturday|\bSat\b/i, 'S'],
  [/Sunday|\bSun\b/i, 'S'],
  [/Monday|\bMon\b/i, 'M'],
  [/Tuesday|\bTue\b/i, 'T'],
  [/Wednesday|\bWed\b/i, 'W'],
  [/Thursday|\bThu\b/i, 'T'],
  [/Friday|\bFri\b/i, 'F'],
];

const LETTER_ONLY: Record<string, string> = {
  א: 'א',
  ב: 'ב',
  ג: 'ג',
  ד: 'ד',
  ה: 'ה',
  ו: 'ו',
  ש: 'ש',
  S: 'S',
  M: 'M',
  T: 'T',
  W: 'W',
  F: 'F',
};

export function formatDatePickerWeekDay(dayName: string): string {
  const trimmed = dayName.trim();
  if (!trimmed) return '';

  for (const [pattern, letter] of WEEKDAY_RULES) {
    if (pattern.test(trimmed)) return letter;
  }

  const stripped = trimmed.replace(/[׳'"]/g, '');
  if (stripped.length === 1 && LETTER_ONLY[stripped]) return LETTER_ONLY[stripped];

  return stripped.charAt(0);
}
